import { Redirect, Route } from "wouter";

export function AgeVerifiedRoute({
  path,
  component: Component,
}: {
  path: string;
  component: React.ComponentType<any>;
}) {
  const isVerified = localStorage.getItem("age_verified") === "true";

  if (!isVerified) {
    return (
      <Route path={path}>
        <Redirect to="/verify" />
      </Route>
    );
  }

  return <Route path={path} component={Component} />;
}
